import { render, staticRenderFns } from "./index_chengdu.vue?vue&type=template&id=74b0fdf8&scoped=true"
import script from "./index_chengdu.vue?vue&type=script&lang=js"
export * from "./index_chengdu.vue?vue&type=script&lang=js"
import style0 from "./index_chengdu.vue?vue&type=style&index=0&id=74b0fdf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0fdf8",
  null
  
)

export default component.exports